export {
    createSmtpSetup,
    deleteSmtpSetup,
    getAllSmtpData,
    updateSmtpActiveStatus
} from './SmtpSetup';